import { EnquirySiteVisitStatus } from "features/EnquirySiteVisits/constants/enquiry-site-visit.constants";

/** Normalizes API status strings for comparison (case, hyphen vs underscore). */
export function normalizeSiteVisitStatus(
  status: string | null | undefined,
): string {
  return String(status ?? "")
    .trim()
    .toUpperCase()
    .replace(/-/g, "_");
}

export function isTerminalSiteVisitStatus(
  status: string | null | undefined,
): boolean {
  const st = normalizeSiteVisitStatus(status);
  return (
    st === EnquirySiteVisitStatus.COMPLETED ||
    st === EnquirySiteVisitStatus.CANCELLED
  );
}

export function canReassignSiteVisit(
  status: string | null | undefined,
): boolean {
  return !isTerminalSiteVisitStatus(status);
}

export function shouldShowSiteVisitActionButtons(
  status: string | null | undefined,
): boolean {
  return !isTerminalSiteVisitStatus(status);
}
